import { Badge, IconButton, IconName } from '@optimus-web/core';

interface NotesIconButtonProps {
    notesCount: number;
    onClick: () => void;
}

export const NotesIconButton = ({ notesCount, onClick }: NotesIconButtonProps) => {
    const button = <IconButton size="small" icon={IconName.Notes} variant="ghost" onClick={onClick} type="submit" />;

    if (notesCount === 0) return button;

    return (
        <Badge content={notesCount} offset={16}>
            {button}
        </Badge>
    );
};
